// App.js
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";

// Public Pages
import Home from "./Components/Pages/Home";
import About from "./Components/Pages/About";
import ThematicPillars from "./Components/Pages/ThematicPillars";
import Projects from "./Components/Pages/Projects";
import ImpactStories from "./Components/Pages/ImpactStories";
import Gallery from "./Components/Pages/Gallery";
import Resources from "./Components/Pages/Resources";
import Media from "./Components/Pages/Media";
import Team from "./Components/Pages/Team";
import Contact from "./Components/Pages/Contact";
import Donate from "./Components/Pages/Donate";
import BlogList from "./Components/Pages/BlogList";
import BlogDetail from "./Components/Pages/BlogDetail";
import Partners from "./Components/Pages/Partners"; // Add this import

// Admin Pages
import Login from "./Components/Pages/Admin/Login";
import AdminLayout from "./Components/Pages/Admin/AdminLayout";
import Dashboard from "./Components/Pages/Admin/Dashboard";

// Admin Management Pages
import Pillars from "./Components/Pages/Admin/Pillars";
import AdminProjects from "./Components/Pages/Admin/Projects";
import Stories from "./Components/Pages/Admin/Stories";
import AdminGallery from "./Components/Pages/Admin/Gallery";
import AdminResources from "./Components/Pages/Admin/Resources";
import AdminMedia from "./Components/Pages/Admin/Media";

// Lazy load BlogManagement
const BlogManagement = lazy(() => import("./Components/Pages/Admin/BlogManagement"));

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Login */}
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<Login />} />
        
        {/* Admin Layout with Sidebar */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="pillars" element={<Pillars />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="stories" element={<Stories />} />
          <Route path="gallery" element={<AdminGallery />} />
          <Route path="resources" element={<AdminResources />} />
          <Route path="media" element={<AdminMedia />} />
          <Route 
            path="blog" 
            element={
              <Suspense fallback={
                <div className="flex items-center justify-center h-64">
                  <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primaryGold mx-auto"></div>
                    <p className="mt-4 text-gray-600">Loading Blog Management...</p>
                  </div>
                </div>
              }>
                <BlogManagement />
              </Suspense>
            } 
          />
        </Route>
        
        {/* Public Routes with Navbar/Footer */}
        <Route path="/" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Home /></div>
            <Footer />
          </>
        } />
        <Route path="/about" element={
          <>
            <Navbar />
            <div className="min-h-screen"><About /></div>
            <Footer />
          </>
        } />
        <Route path="/thematic-pillars" element={
          <>
            <Navbar />
            <div className="min-h-screen"><ThematicPillars /></div>
            <Footer />
          </>
        } />
        <Route path="/projects" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Projects /></div>
            <Footer />
          </>
        } />
        <Route path="/impact-stories" element={
          <>
            <Navbar />
            <div className="min-h-screen"><ImpactStories /></div>
            <Footer />
          </>
        } />
        <Route path="/gallery" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Gallery /></div>
            <Footer />
          </>
        } />
        <Route path="/resources" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Resources /></div>
            <Footer />
          </>
        } />
        <Route path="/media" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Media /></div>
            <Footer />
          </>
        } />
        
        {/* Blog Routes */}
        <Route path="/blog" element={
          <>
            <Navbar />
            <div className="min-h-screen"><BlogList /></div>
            <Footer />
          </>
        } />
        <Route path="/blog/:id" element={
          <>
            <Navbar />
            <div className="min-h-screen"><BlogDetail /></div>
            <Footer />
          </>
        } />
        
        {/* Partners Route */}
        <Route path="/partners" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Partners /></div>
            <Footer />
          </>
        } />
        
        <Route path="/team" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Team /></div>
            <Footer />
          </>
        } />
        <Route path="/contact" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Contact /></div>
            <Footer />
          </>
        } />
        <Route path="/donate" element={
          <>
            <Navbar />
            <div className="min-h-screen"><Donate /></div>
            <Footer />
          </>
        } />
      </Routes>
    </Router>
  );
}

export default App;